import { Button, Card, Container, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, ListItem, ListItemIcon, ListItemText, Slide } from "@mui/material";
import { AttachFile, Close, Delete, Download, PictureAsPdfRounded } from "@mui/icons-material";
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Checkbox from "@mui/material/Checkbox";
import ImagePreviewPopup from "./ImagePreviewPopup";

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default function DocumentPopup(props) {
    const { t } = useTranslation("translation");
    const [selectedList, setSelectedList] = useState(props.list);
    const [disableDocumentDelete, setDisableDocumentDelete] = useState(true);
    const [selectedEquipmentDocuments, setSelectedEquipmentDocuments] = useState(props.equipmentDocuments);
    const [disableEquipmentDocumentDelete, setDisableEquipmentDocumentDelete] = useState(true);

    useEffect(() => {
        setSelectedList(props.list);
    }, [props.list]);

    useEffect(() => {
        setSelectedEquipmentDocuments(props.equipmentDocuments);
    }, [props.equipmentDocuments]);

    const handleChange = (index) => () => {
        let updatedSelectedData = selectedList.slice();
        updatedSelectedData[index] = { ...updatedSelectedData[index], checked: !updatedSelectedData[index]?.checked };
        setSelectedList(updatedSelectedData);
        let newDisableDocumentDelete = true;
        updatedSelectedData.forEach((item) => {
            if (item.checked) {
                newDisableDocumentDelete = false;
            }
        });
        setDisableDocumentDelete(newDisableDocumentDelete);
    };

    const handleChangeEquipmentDocuments = (index) => () => {
        let updatedSelectedData = selectedEquipmentDocuments.slice();
        updatedSelectedData[index] = { ...updatedSelectedData[index], checked: !updatedSelectedData[index]?.checked };
        setSelectedEquipmentDocuments(updatedSelectedData);
        let newDisableEquipmentDocumentDelete = true;
        updatedSelectedData.forEach((item) => {
            if (item.checked) {
                newDisableEquipmentDocumentDelete = false;
            }
        });
        setDisableEquipmentDocumentDelete(newDisableEquipmentDocumentDelete);
    };

    function checkiOSVersion() {
        const agent = window.navigator.userAgent;
        const start = agent.indexOf("OS ");
        console.log(agent);

        if ((agent.indexOf("iPhone") > -1 || agent.indexOf("iPad") > -1) && start > -1) {
            return window.Number(agent.substr(start + 3, 3).replace("_", "."));
        }
        return 0;
    }

    const downloadDocument = (file) => {
        const iosVer = checkiOSVersion();
        console.log(iosVer);
        if (iosVer >= 20) {
            const iframe = `<input type='button' style='font-weight: bold;display: inline;' value='Close' onclick='window.opener = self;window.close();'><iframe width='100%' height='100%' src='${file.blob}'></iframe>`;
            const x = window.open();
            x.document.open();
            x.document.write(iframe);
            x.document.title = file.name.slice(file.name.indexOf("_") + 1);
            x.document.close();
        } else {
            const fileURL = window.URL.createObjectURL(file.blob);
            const a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            a.href = fileURL;
            a.target = "_self";
            a.download = file.name.slice(file.name.indexOf("_") + 1);
            a.click();
            setTimeout(() => {
                window.URL.revokeObjectURL(fileURL);
            }, 5000);
        }
    };

    const renderFilePreview = (file) => {
        const fileExtension = file.name.split(".").pop();
        if (["jpg", "jpeg", "png", "gif"].includes(fileExtension)) {
            return (
                <img
                    id={`docp_Img_preview_${file.name}`}
                    width={38}
                    height={38}
                    alt={file.name}
                    src={window.URL.createObjectURL(file.blob)}
                    onClick={() => handleClickImage(file)}
                    style={{ cursor: "pointer" }}
                />
            );
        } else if (["pdf"].includes(fileExtension)) {
            return <PictureAsPdfRounded id={`docp_Pdf_preview_${file.name}`} fontSize="large" />;
        } else {
            return <AttachFile id={`docp_AttachFile_preview_${file.name}`} fontSize="large" />;
        }
    };

    const getFileSize = (file) => {
        if (Math.round(file.blob.size / 100) / 10 > 1000) {
            return `${(Math.round(file.blob.size / 100) / 10000).toFixed(1)} MB`;
        } else {
            return `${(Math.round(file.blob.size / 100) / 10).toFixed(1)} KB`;
        }
    };

    const getDocumentItem = (document, index, onClickCheckbox) => {
        return (
            <Card key={index} id={`docp_Card_${index}`} elevation={2} sx={{ marginTop: 1, marginBottom: 2, border: "1px solid #e0e0e0" }}>
                <ListItem id={`docp_ListItem_${index}`}>
                    <ListItemIcon id={`docp_ListItemIcon_${index}`}>{renderFilePreview(document)}</ListItemIcon>
                    <ListItemText
                        id={`docp_ListItemText_${index}`}
                        primary={document.name.slice(document.name.indexOf("_") + 1)}
                        secondary={getFileSize(document)}
                        primaryTypographyProps={{
                            style: {
                                wordBreak: "break-all",
                            },
                        }}
                    />
                    <ListItemIcon id={`docp_ListItemIcon_2_${index}`}>
                        <IconButton id={`docp_IconButton_${index}`} onClick={() => downloadDocument(document)}>
                            <Download id={`docp_Download_${index}`} />
                        </IconButton>
                    </ListItemIcon>
                    {!props.isCheckListDocuments ? (
                        <Checkbox id={`docp_Checkbox_${index}`} color="secondary" checked={document.checked} onClick={onClickCheckbox} inputProps={{ itemIndex: index }} tabIndex={-1} />
                    ) : null}
                </ListItem>
            </Card>
        );
    };

    const [isImagePreviewOpen, setIsImagePreviewOpen] = useState(false);
    const [previewImage, setPreviewImage] = useState();
    const handleClickImage = (image) => {
        setPreviewImage(image);
        setIsImagePreviewOpen(true);
    };

    return (
        <Container id="docp_Container">
            <Dialog id="docp_Dialog" open={props.open} onClose={props.close} TransitionComponent={Transition}>
                <DialogTitle id="docp_DialogTitle_Close">
                    <IconButton
                        aria-label="close"
                        onClick={props.close}
                        sx={{
                            position: "absolute",
                            right: 8,
                            top: 8,
                            marginLeft: 10,
                        }}
                    >
                        <Close />
                    </IconButton>
                </DialogTitle>
                {props.isMaintenanceDocuments ? (
                    <div>
                        <DialogTitle id="docp_DialogTitle">{t("Documents")}</DialogTitle>
                        <DialogContent id="docp_DialogContent">{props.list.map((document, index) => getDocumentItem(document, index, handleChange(index)))}</DialogContent>
                        <DialogActions id="docp_DialogActions">
                            <Container sx={{ display: "flex", justifyContent: "center" }}>
                                <Button id="docp_b_delete" variant="outlined" onClick={() => props.deleteFile(selectedList)} disabled={disableDocumentDelete} color="error" startIcon={<Delete />}>
                                    {t("Delete")}
                                </Button>
                            </Container>
                        </DialogActions>
                    </div>
                ) : null}
                {props.isEquipmentDocuments ? (
                    <div>
                        <DialogTitle id="docp_DialogTitle_Eq">{t("EquipmentDocuments")}</DialogTitle>
                        <DialogContent id="docp_DialogContent_Eq">
                            {props.equipmentDocuments.map((document, index) => getDocumentItem(document, index, handleChangeEquipmentDocuments(index)))}
                        </DialogContent>
                        <DialogActions id="docp_DialogActions_Eq">
                            <Container sx={{ display: "flex", justifyContent: "center" }}>
                                <Button
                                    id="docp_b_delete_Eq"
                                    variant="outlined"
                                    onClick={() => props.deleteEquipmentFiles(selectedEquipmentDocuments)}
                                    disabled={disableEquipmentDocumentDelete}
                                    color="error"
                                    startIcon={<Delete />}
                                >
                                    {t("Delete")}
                                </Button>
                            </Container>
                        </DialogActions>
                    </div>
                ) : null}
                {props.isCheckListDocuments ? (
                    <div>
                        <DialogTitle id="docp_DialogTitle_Eq">{t("Documents")}</DialogTitle>
                        <DialogContent id="docp_DialogContent_Eq">
                            {props.equipmentDocuments.map((document, index) => getDocumentItem(document, index, handleChangeEquipmentDocuments(index)))}
                        </DialogContent>
                        <DialogActions id="docp_DialogActions_Eq">
                        </DialogActions>
                    </div>
                ) : null}
            </Dialog>

            {isImagePreviewOpen ? <ImagePreviewPopup isImagePreviewOpen={isImagePreviewOpen} previewImage={previewImage} handleClose={() => setIsImagePreviewOpen(false)} /> : null}
        </Container>
    );
}
